/**
 * @fileoverview POST handler for the "/apps/catalogs/:catalog_id/items/:item_id/refresh_agentic_field" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsCatalogsCatalogIdItemsItemIdRefreshAgenticFieldCacheKeys } from "./constants";
import type {
  PostAppsCatalogsCatalogIdItemsItemIdRefreshAgenticFieldProps,
  AppsCatalogsCatalogIdItemsItemIdRefreshAgenticFieldResult,
} from "./types";

export const postAppsCatalogsCatalogIdItemsItemIdRefreshAgenticField = reactQueryMutationAdapter(
  appsCatalogsCatalogIdItemsItemIdRefreshAgenticFieldCacheKeys,
  ({
    appGroupId,
    catalogId,
    itemId,
    fieldName,
    agentConfiguration,
  }: PostAppsCatalogsCatalogIdItemsItemIdRefreshAgenticFieldProps): Promise<AppsCatalogsCatalogIdItemsItemIdRefreshAgenticFieldResult> => {
    return fetch(
      `/apps/${appGroupId}/catalogs/${catalogId}/items/${itemId}/refresh_agentic_field`,
      "POST",
      {
        field_name: fieldName,
        agent_configuration: agentConfiguration,
      },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
